export function atLeastOneValidator(controlNames: string[]){
    return (controlGroup) => {
      const controls = controlGroup.controls;  
      if (controls) {
        const theOne = controlNames.find(controlName => {
          const control = controls[controlName];
          if (!control) {
            console.warn(`Control "${controlName}" no encontrado en el FormGroup.`);
            return false;  
          }
  
          const value = control.value;
          return !Array.isArray(value)
            ? (value !== '' && value !== undefined && value !== null) 
            : (value.length > 0);  
        });
  
        if (!theOne) {
          return {
            atLeastOneRequired: {
              text: 'Se debe ingresar al menos un filtro válido en los controles especificados.'
            }
          };
        }
      }
      return null;  
    };
  }